import { render, staticRenderFns } from "./SendCodeNoTel.vue?vue&type=template&id=4f5cd140&scoped=true"
import script from "./SendCodeNoTel.vue?vue&type=script&lang=js"
export * from "./SendCodeNoTel.vue?vue&type=script&lang=js"
import style0 from "./SendCodeNoTel.vue?vue&type=style&index=0&id=4f5cd140&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5cd140",
  null
  
)

export default component.exports